import React from 'react'
import actions from 'redux/actions'
import { useMedia, useCallback } from 'sb-hooks'
import { constants } from 'common/helpers'

import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Modal from 'components/_new/modal/Modal/Modal'
import MobileModal from 'components/_new/modal/MobileModal/MobileModal'
import { Box, Overlay } from 'components/_new/layout'
import Headline from 'components/_new/typography/deprecated/Headline/Headline'
import { Button, ButtonsInRow } from 'components/_new/controls'
import { Image } from 'components/_new/ui'

import messages from './messages'

import successImg from '!!src-loader!./images/success.png'


const close = () => actions.models.modals.close(constants.modals.humble.FeedbackFormSuccess)

const FeedbackSuccessModal = ({ data: { title, text, alignCenter, brandButtonProps = {}, textButtonProps = {} } }) => {
  const { isMobile } = useMedia()

  const titleMessage = title || messages.title
  const textMessage = text || messages.text

  const handleBrandButtonClick = useCallback(() => {
    close()

    if (typeof brandButtonProps.onClick === 'function') {
      brandButtonProps.onClick()
    }
  }, [ brandButtonProps ])

  const handleTextButtonClick = useCallback(() => {
    close()

    if (typeof textButtonProps.onClick === 'function') {
      textButtonProps.onClick()
    }
  }, [ textButtonProps ])

  const buttonsNode = (
    <ButtonsInRow alignLeft={!alignCenter} reversedOnDesktop>
      <Button
        size="md"
        color="brand"
        title={brandButtonProps.title || messages.ok}
        onClick={handleBrandButtonClick}
        fullWidth
      />
      {
        Boolean(textButtonProps.title) && (
          <Button
            size="md"
            title={textButtonProps.title}
            onClick={handleTextButtonClick}
            fullWidth
          />
        )
      }
    </ButtonsInRow>
  )

  return isMobile ? (
    <MobileModal onBackdropClick={close}>
      <Box alignCenter>
        <Box mt={24} mb={24}>
          <Image {...successImg} />
        </Box>
        <Headline title={titleMessage} subTitle={textMessage} size="lg" mutedSubTitle={false} />
        {buttonsNode}
      </Box>
    </MobileModal>
  ) : (
    <ModalContainer>
      <Overlay onClick={close} />
      <Modal onClose={close} footerNode={buttonsNode}>
        <Box alignCenter={alignCenter}>
          <Box mt={24} mb={48}>
            <Image {...successImg} />
          </Box>
          <Headline title={titleMessage} subTitle={textMessage} size="lg" mutedSubTitle={false} />
        </Box>
      </Modal>
    </ModalContainer>
  )
}


export default FeedbackSuccessModal
